import { render, staticRenderFns } from "./CheckinPage.vue?vue&type=template&id=4859f822&scoped=true"
import script from "./CheckinPage.vue?vue&type=script&lang=js"
export * from "./CheckinPage.vue?vue&type=script&lang=js"
import style0 from "./CheckinPage.vue?vue&type=style&index=0&id=4859f822&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4859f822",
  null
  
)

export default component.exports